export class Entrega {
  entregaId: number | null = null;

  localEntrega: string = '';

  nomeDestinatario: string = '';

  cpfDestinatario: string = '';

  setorDestinatario: string = '';

  dataEntrega: Date | string | null = null;
}
